export default __webpack_public_path__ + "static/media/morph_logo_rgb.4de8cc4a.svg";